import { authService } from "myfirebase";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";

const Profile = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  document.title = "[User name here]'s Profile | Atrable";

  const { uid } = useParams();
  // https://css-tricks.com/the-hooks-of-react-router/#useparams
  const [userId, setUserId] = useState(uid);
  const [name, setName] = useState();

  return (
    <div style={{ minHeight: "100vh" }}>
      <div style={{ textAlign: "center" }}>
        <img
          src="https://lh3.googleusercontent.com/fife/ABSRlIpB7kpyrWZQuwveIzQ6i4R74Scn4E0nZWbmsAO8G0onwVqG3V_wJexsIVIUk7-S3hKyUwtB30t1y_VPT79rnuScZM2dU5TLkH5VRCtsHsdaJXwlVTazD9vaJ29nVTLIsnWzlj85UcjT0N3SC3JkJGrlbjvKKAq8bGRiNlgi-VIr-fIxUhUQzh8_XUKFOVYjkR0zvXKCBw3RGM53CIT894nsDGcCTM_RdfIBEPsLcShdnnJuUhd7RRk7aQNwMutZNEc2-dksdbCN2lOGLiBzbMu1DJJ56ony_Ni8HoiX97DpeLWXRZ0mLV8dfPxzv-6NzCjZXc97AeZ3FggAFWap6xObPzKBvgMocksIvwxSetwoS7Xr55eERfjbO17qpKMaxRAIK37mMiPjaLzcPjnCD1HGQTUrVO37Nx0CSlIj-GlT5u0jD1LbiBdVckBUL5XQcHIXcFwfHosAsLCloPwBkIYLlqibgSoPpkBQ_2LGwFVSSPEGdwsDlg5SE7xp-MMobCfvTdqkSDHREo9zkksNLcM2Bk0U7Jc6AAdBFrbpUbrEWZP-1dTN5Ft1llpcHXTpJ2tGSIOjgwO6p_DAoSQc3h8uZbSggzfrXkWkAROMuw-wVsMAQ_hzDQ8DD5kTdwJfmLhO1TQjPhX7FdkQp-eTES11mBwpdp8Wz_7L3um1bw3foOjqaSPsj7g-OT9ynoAQucRKbdlag8asCWv1mWWxWv0SomwfuYPMQcaVAMjgIviNxwI=s32-c"
          alt="user profile image"
          style={{
            left: 0,
            right: 0,
            marginLeft: "auto",
            marginRight: "auto",
            marginTop: -75,
            width: 150,
            height: 150,
            borderRadius: 75,
            // backgroundImage:
            //   "url(https://lh3.googleusercontent.com/fife/ABSRlIpB7kpyrWZQuwveIzQ6i4R74Scn4E0nZWbmsAO8G0onwVqG3V_wJexsIVIUk7-S3hKyUwtB30t1y_VPT79rnuScZM2dU5TLkH5VRCtsHsdaJXwlVTazD9vaJ29nVTLIsnWzlj85UcjT0N3SC3JkJGrlbjvKKAq8bGRiNlgi-VIr-fIxUhUQzh8_XUKFOVYjkR0zvXKCBw3RGM53CIT894nsDGcCTM_RdfIBEPsLcShdnnJuUhd7RRk7aQNwMutZNEc2-dksdbCN2lOGLiBzbMu1DJJ56ony_Ni8HoiX97DpeLWXRZ0mLV8dfPxzv-6NzCjZXc97AeZ3FggAFWap6xObPzKBvgMocksIvwxSetwoS7Xr55eERfjbO17qpKMaxRAIK37mMiPjaLzcPjnCD1HGQTUrVO37Nx0CSlIj-GlT5u0jD1LbiBdVckBUL5XQcHIXcFwfHosAsLCloPwBkIYLlqibgSoPpkBQ_2LGwFVSSPEGdwsDlg5SE7xp-MMobCfvTdqkSDHREo9zkksNLcM2Bk0U7Jc6AAdBFrbpUbrEWZP-1dTN5Ft1llpcHXTpJ2tGSIOjgwO6p_DAoSQc3h8uZbSggzfrXkWkAROMuw-wVsMAQ_hzDQ8DD5kTdwJfmLhO1TQjPhX7FdkQp-eTES11mBwpdp8Wz_7L3um1bw3foOjqaSPsj7g-OT9ynoAQucRKbdlag8asCWv1mWWxWv0SomwfuYPMQcaVAMjgIviNxwI=s32-c)",
            // backgroundRepeat: "no-repeat",
            // backgroundSize: "cover",
            // backgroundPosition: "center",
            boxShadow: "rgba(0, 0, 0, 0.5) 0px 0px 30px",
            marginTop: 120,
            marginBottom: 20,
          }}
        />
      </div>
      <h1 style={{ textAlign: "center" }}>{name}</h1>
    </div>
  );
};
export default Profile;
